export default __webpack_public_path__ + "static/media/48.53f78b48.png";